<template>
  <div class="ds-card-actions">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DsCardActions',
  props: {
    icon: {
      type: String,
      default: undefined,
    },
  },
};
</script>
<style lang="stylus" scoped>
.ds-card-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;

  .v-btn {
    margin: 0;
  }
}
</style>
